// extracted by mini-css-extract-plugin
module.exports = {"institutionWrapper":"institution_institutionWrapper__1Jrer"};